export default __webpack_public_path__ + "static/media/Ellipse.9e441370.svg";